export enum SavingTypedInField {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}
